module.exports = __webpack_public_path__ + "img/shipping-and-delivery.8c844efc.svg";